import {ICampaignStatusEnum} from '../../campaigns/interfaces/ICampaigns';
import OrderLists from '../components/list';

const OrderFinished = () => {
  return <OrderLists status={ICampaignStatusEnum.FINISHED} />;
};

export default OrderFinished;
